<template>
  <v-card flat color="transparent" class="elevation-12">
    <div style="margin: auto 3%">
      <!-- search categories -->
      <!-- search by word -->
      <div
        style="
          min-width: 700px;
          display: flex;
          flex-flow: wrap;
          justify-content: start;
          align-items: center;
          height: 60px;
        "
      >
        <div style="font-size: 23px; font-weight: bold; width: 120px">
          Category
        </div>
        <v-select
          v-model="column"
          label="Category"
          :items="searchSelects"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px; height: 60px"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          clearable
          style="
            margin: auto 10px;
            max-width: 150px;
            min-width: 100px;
            height: 56px;
          "
          placeholder="Search"
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 140px; min-width: 120px; height: 35px"
          @click="searchByWord"
          >Search</v-btn
        >
        <v-btn
          v-if="$store.state.account.userInfo.Permission === 1"
          @click="$store.commit('common/changeAddEmployeeModalView')"
          class="rounded-lg"
          color="#05523E"
          style="color: #ffffff; height: 40px; position: absolute; right: 3%"
        >
          <v-icon color="#ffffff" style="margin-right: 5px"
            >mdi-plus-circle-outline</v-icon
          >
          Add Employee
        </v-btn>
      </div>
      <div v-show="isShow" style="padding-bottom: 20px; margin-top: 10px">
        <v-data-table
          :headers="headers"
          :items="$store.state.account.employeeList"
          :page.sync="page_No"
          :items-per-page="10"
          hide-default-footer
          class="elevation-3"
          :loading="loading"
        >
          <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                        <th v-for="h in headers" v-bind:key="h.text">
                            <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                        </th>
                        </tr>
                    </thead>
                    </template> -->
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.Cashier_ID }}</td>
              <td>{{ item.Id }}</td>
              <td>{{ item.Email }}</td>
              <td style="justify-content: right">
                <v-menu offset-y>
                  <template
                    v-slot:activator="{ on, attrs }"
                    v-if="$store.state.account.userInfo.Permission === 1"
                  >
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="transparent"
                      class="elevation-0"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-title
                      @click="openEditEmployeeModal(item._id)"
                      style="
                        padding: 0px 15px;
                        font-size: 15px;
                        cursor: pointer;
                      "
                      >Edit</v-list-item-title
                    >
                    <v-list-item-title
                      @click="openDeleteEmployeeModal(item._id, item.Id)"
                      style="
                        padding: 5px 15px 0px;
                        font-size: 15px;
                        cursor: pointer;
                      "
                      >Delete</v-list-item-title
                    >
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            style="padding-top: 8px"
            color="#05523E"
            v-model="page_No"
            :length="$store.state.account.employeePages"
            :total-visible="10"
            @input="movePage"
          />
          <div v-if="$store.state.common.addEmployeeModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.addEmployeeModalView"
              max-width="35%"
            >
              <AddEmployeeModal @getEmployeeList="getEmployeeList" />
            </v-dialog>
          </div>
          <div v-if="$store.state.common.editEmployeeModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.editEmployeeModalView"
              max-width="35%"
            >
              <EditEmployeeModal @getEmployeeList="getEmployeeList" />
            </v-dialog>
          </div>
          <div v-if="$store.state.common.deleteEmployeeModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.deleteEmployeeModalView"
              max-width="27%"
            >
              <DeleteEmployeeModal
                v-bind:propId="propId"
                v-bind:userId="userId"
                @getEmployeeList="getEmployeeList"
              />
            </v-dialog>
          </div>
        </div>
      </div>
      <div
        v-show="!$store.state.common.isLoading && !isShow"
        style="font-size: 20px"
      >
        <div
          style="
            margin: 0% 0% 0% 420px;
            font-size: 40px;
            color: #05523e;
            font-weight: bold;
          "
        >
          No data was retrieved.
        </div>
        <img
          style="width: 700px; height: 600px; margin: 0% 0% 0% 250px"
          src="@/assets/noData.jpg"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import { GETADMIN, GETADMINLENGTH } from "@/graphql/AccountQueries.js";
import AddEmployeeModal from "@/components/modal/AddEmployeeModal.vue";
import EditEmployeeModal from "@/components/modal/EditEmployeeModal.vue";
import DeleteEmployeeModal from "@/components/modal/DeleteEmployeeModal.vue";

export default {
  components: {
    AddEmployeeModal,
    EditEmployeeModal,
    DeleteEmployeeModal,
  },
  data() {
    return {
      searchSelects: [
        { name: "Category", value: "" },
        { name: "Cashier Id", value: "Cashier_ID" },
        { name: "Id", value: "id" },
        { name: "Email", value: "email" },
      ],
      column: "",
      search: "",
      page_No: 1,
      headers: [
        {
          text: "Cashier Id",
          align: "start",
          value: "Cashier_ID",
          //   , sort: (a, b) => a.localeCompare(b)
        },
        { text: "Id", value: "Id", sort: (a, b) => a.localeCompare(b) },
        { text: "Email", value: "Email", sort: (a, b) => a.localeCompare(b) },
        { text: "", value: "", sortable: false },
      ],
      propId: "",
      userId: "",
      Page_Size: 10,
      isShow: true,
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.getEmployeeListPage();
    await this.getEmployeeList();
    this.loading = false;
  },
  methods: {
    async getEmployeeListPage() {
      try {
        const req = { Column: this.column, Search: this.search };

        const employeePage = await runGqlQuery(GETADMINLENGTH, req);

        this.$store.state.account.employeePages = Math.ceil(
          employeePage.getAdminsLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getEmployeeList() {
      try {
        const req = {
          Column: this.column,
          Search: this.search,
          Page_No: this.page_No - 1,
          Page_Size: 10,
        };

        const result = await this.$store.dispatch(
          "account/getEmployeeList",
          req
        );

        if (result == "no data") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async openEditEmployeeModal(_id) {
      try {
        const employeeResult = await runGqlQuery(GETADMIN, {
          Column: "_id",
          Search: _id + "",
        });

        if (
          employeeResult != undefined &&
          employeeResult.getAdmins.length != 0
        ) {
          await this.$store.commit("account/setEmployeeOne", {
            getEmployeeList: employeeResult.getAdmins[0],
          });
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "There is no employee!",
          });
        }
        this.$store.commit("common/changeEditEmployeeModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async openDeleteEmployeeModal(_id, Id) {
      try {
        this.propId = _id;
        this.userId = Id;
        this.$store.commit("common/changeDeleteEmployeeModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async searchByWord() {
      this.loading = true;
      try {
        if (this.column === "" && this.search == null) {
          await this.searchEmployee();
        } else if (this.column === "" && this.search !== "") {
          this.loading = false;
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category.",
          });
        }
        await this.searchEmployee();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchEmployee() {
      this.loading = true;
      try {
        await this.getEmployeeListPage();
        this.page_No = 1;
        await this.getEmployeeList();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async movePage(page) {
      this.loading = true;
      try {
        this.page_No = page;
        await this.getEmployeeList();
      } catch (err) {
        console.error(err);
      }
      this.loading = true;
    },
  },
};
</script>
